import { render, staticRenderFns } from "./EmailsTagsInput.vue?vue&type=template&id=fbb6cd60&scoped=true&"
import script from "./EmailsTagsInput.vue?vue&type=script&lang=js&"
export * from "./EmailsTagsInput.vue?vue&type=script&lang=js&"
import style0 from "./EmailsTagsInput.vue?vue&type=style&index=0&id=fbb6cd60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb6cd60",
  null
  
)

export default component.exports